module.exports = __webpack_public_path__ + "img/recent-stats.8ecf5f6c.jpg";